import z from "zod";
import { TicketEventIdSchema } from "./TicketEvent";
import { TicketOrderIdSchema } from "./TicketOrder";
import { Log } from "@greeter/log";

export const TicketIdSchema = z.string().brand("TicketId");
export type TicketId = z.infer<typeof TicketIdSchema>;
export const TicketSchema = z.object({
  id: TicketIdSchema,
  ticketEventId: TicketEventIdSchema,
  ticketOrderId: TicketOrderIdSchema,
  checkedInAt: z
    .string()
    .or(z.date())
    .optional()
    .nullable()
    .transform((s) => {
      let sactual = s;

      // TODO: Hard to say how robust this is.
      if (typeof sactual === "string" && sactual.endsWith("Z"))
        sactual = sactual + "Z";

      const t = sactual ? new Date(sactual) : null;
      Log.debug("Checked in at", { s, asDate: t, sactual });
      return t;
    }),
});
export type Ticket = z.infer<typeof TicketSchema>;
